export default __webpack_public_path__ + "static/media/nft1.e2a47135.png";